import Web3 from 'web3';

import { network } from './blockchain'
import Log from '../utils/Log';

export const getWeb3 = () => {
  let web3js;

  if (window.ethereum) { // Modern dapp browsers...
    web3js = new Web3(window.ethereum);
    Log.info(`Injected ethereum ${web3js.version.api} detected.`);
  } else if (window.web3) { // Legacy dapp browsers...
    web3js = new Web3(window.web3.currentProvider);
    Log.info(`Injected web3 ${web3js.version.api} detected.`);
    // Acccounts always exposed
  } else { // Non-dapp browsers...
    web3js = new Web3(new Web3.providers.HttpProvider(network.fallbackProvider));
    Log.info(`No injected web3 detected. Using version ${web3js.version.api} with network provider: ${network.fallbackProvider}.`);
  }

  return web3js;
};

export const requestWeb3AccountAccess = async (grantedCallback = () => {}) => {
  if (window.ethereum) {
    try {
      await window.ethereum.enable();
      Log.info('Access to web3 account granted.');
      grantedCallback();
    } catch (error) {
      Log.info(`Access to web3 account denied: ${error}`);
    }
  } else {
    grantedCallback();
  }
}



// WEBPACK FOOTER //
// ./src/config/web3.js